var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99935 13.6666H9.99935C10.353 13.6666 10.6921 13.5261 10.9422 13.2761C11.1922 13.026 11.3327 12.6869 11.3327 12.3333V4.33325L7.33268 0.333252H1.99935C1.64573 0.333252 1.30659 0.473728 1.05654 0.723776C0.806491 0.973825 0.666016 1.31296 0.666016 1.66659V12.3333C0.666016 12.6869 0.806491 13.026 1.05654 13.2761C1.30659 13.5261 1.64573 13.6666 1.99935 13.6666ZM6.66602 1.66659L9.99935 4.99992H6.66602V1.66659ZM3.33268 8.33325H5.33268V6.33325H6.66602V8.33325H8.66602V9.66658H6.66602V11.6666H5.33268V9.66658H3.33268V8.33325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.34d8a9b8540e50e37127c1f8649bbba4.svg";
export { ForwardRef as ReactComponent };